var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ac7cb7e2c0ad8caa9655032bffed09f5da91960d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["heavnn@heavnn"]={id:"ac7cb7e2c0ad8caa9655032bffed09f5da91960d"};
      